import BScroll from "better-scroll"
import ScrollBar from '@better-scroll/scroll-bar'
BScroll.use(ScrollBar)

export default BScroll;



//////////////////
// WEBPACK FOOTER
// ./common/newSelectPlace/useBScroll.js
// module id = jnU9
// module chunks = 36